/* Check for dog Breed Value */
if ($('#SingleOptionBreed').length) {    

  $('#SingleOptionBreed').on('change', function() {
    selectedBreed = this.value;
    //console.log(selectedBreed);
    //alert(selectedBreed);
    if ( selectedBreed == "Afghansk mynde") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Airedale terrier") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Akita") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Alaskan husky") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Alaskan Klee Kai") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Alaskan malamute") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Amerikansk Staffordshire terrier") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Amerikansk cocker spaniel") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Amstaff") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Appenzeller sennenhund") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Australsk Cattle Dog") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Australian Cobberdog") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Australsk kelpie") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Australsk labradoodle") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Australian Shepherd") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Australian Stumpy Tail Cattle Dog") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Australsk terrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Barbet") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Basenji") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Basset hound") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Beagle") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Beagle-Harrier") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Bearded collie") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Belgisk hyrdehund") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Picard / Berger Picard") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Berner sennenhund") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Bichon frisé") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Bichon havanais") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Blodhund") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Border collie") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Borderterrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Borzoi") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Bostonterrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Boxer") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Brandlbracke") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Bullterrier") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Cairnterrier") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Cane Corso") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Cavalier King Charles spaniel") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Cavapoo") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Chihuahua") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Chinese Crested / Kinesisk hårløs") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Chow chow") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Cockapoo") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Cocker spaniel") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Collie") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Corgi") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Coton de Tulear") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Dalmatiner") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Dansk-Svensk Gårdhund") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Dobermann") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Dogo Argentino") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Drever") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Dværgpinscher") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Dværgpudel") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Dværgschnauzer") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Engelsk bulldog") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Engelsk setter") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Engelsk springer spaniel") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Eurasier") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Finsk lapphund") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Finsk spids") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Finsk støver") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Flatcoated retriever") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Foxterrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Fransk bulldog") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Golden retriever") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Gordon setter") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Grand danois") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Greyhound") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Hamiltonstøver") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Harrier") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Irsk soft coated wheaten terrier") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Irsk setter") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Irsk ulvehund") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Irsk vandspaniel") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Islandsk fårehund") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Italiensk mynde") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Jack russell terrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Japanese Chin") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Japansk spids") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Jämthund") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Kai Ken") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Karelsk bjørnehund") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Katte") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Keeshond") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Kishu") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Kleiner Münsterländer") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Kleinspids") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Kooikerhondje") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Korthåret hønsehund") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Kromfohrländer") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Labrador retriever") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Labradoodle") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Lagotto romagnolo") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Lapsk hyrdehund") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Leonberger") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Malshipoo") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Malteser") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Maltipoo") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Manchester terrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Mellempudel") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Miniature American Shepherd") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Mittelspids") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Mops") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Newfoundlænder") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Norfolkterrier") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Norrbottenspids") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Norsk buhund") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Norsk lundehund") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Norsk elghund") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Norwichterrier") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Nova Scotia Duck Tolling retriever") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Papillon") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Parson russell terrier") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Pekingeser") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Pinscher") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Pitbull") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Pointer") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Pomeranian") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Portugisisk vandhund") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Puli") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Pumi") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Pyrenéerhund") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Rhodesian ridgeback") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Rottweiler") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Saluki") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Samojedhund") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Sealyhamterrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Shetland sheepdog") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Shiba inu") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Shih tzu") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Siberian husky") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Silky terrier") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Korthåret foxterrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Spansk vandhund") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Staffordshire bullterrier") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Storpudel") {$(".size-value").text(" XL ")}
else if ( selectedBreed == "Strihåret hønsehund") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Sussex spaniel") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Svensk lapphund") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Gravhund / Tax") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Tibetansk spaniel") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Tibetansk terrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Toypudel") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Schæferhund") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Tysk spids") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Volpino italiano") {$(".size-value").text(" S ")}
else if ( selectedBreed == "Weimaraner") {$(".size-value").text(" XXL ")}
else if ( selectedBreed == "Welsh terrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "West highland white terrier") {$(".size-value").text(" M ")}
else if ( selectedBreed == "Whippet") {$(".size-value").text(" L ")}
else if ( selectedBreed == "Yorkshire terrier") {$(".size-value").text(" S ")}

    else {
      $(".size-value").text("")
    }

    const recomendedOption =document.querySelector(".psr-tool .size-wrapper .size-value").innerText.trim();
    document.querySelectorAll(".variant-input-wrap select option").forEach(function(option) {
      option.removeAttribute("selected");
      const splitedValue=option.value.split(":");
      if (splitedValue[0].trim()==recomendedOption) {
        option.selected = true;
        option.parentNode.dispatchEvent(new Event('change', { bubbles: true }));
      }
  });

  });
}